import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
// import SvgIcon from '@material-ui/core/SvgIcon';

// import CustomTooltip from './DoughnutTooltip';

var morning = false;
var tuesday = false;


class MatrixLine extends Component {

  getColor = (value) => {
    if (this.props.isShort) {
      console.log('short')
      let all = this.props.total;
      let total = value / all;
      if (total < 0.03)
        return 1;
      if (total < 0.06)
        return 2;
      if (total < 0.09)
        return 3;
      if (total >= 0.09)
        return 4;
      return 1;
    } else {
      let all = this.props.total;
      let total = value / all;
      if (total < 0.003)
        return 1;
      if (total < 0.006)
        return 2;
      if (total < 0.009)
        return 3;
      if (total >= 0.009)
        return 4;
      return 1;
    }
  }

  getWidth = (value) => {
    let all = this.props.total;
    let total = value / all;
    if (total < 0.05)
      return 1;
    if (total < 0.1)
      return 2;
    if (total < 0.15)
      return 3;
    return 4;
  }

  getTooltipText = (value) => {
    let all = this.props.total;
    let total = value / all;
    let text = `Total: ${value} - Porcentage: ${parseInt(total * 100)}%`;
    return text;
  }

  getTooltipTitle = (value) => {
    const { horas } = this.props.data;
    if (horas.length > 7) {
      switch (value) {
        case 'L': return 'Lunes';
        case 'M': if (!tuesday) {
          tuesday = true;
          return 'Martes';
        } else {
          tuesday = false;
          return 'Miercoles';
        }
        case 'J': return 'Jueves';
        case 'V': return 'Viernes';
        case 'S': return 'Sábado';
        case 'D': return 'Domingo';
        default: return '';
      }
    } else {
      switch (value) {
        case 'M': if (!morning) {
          morning = true;
          return 'Madrugada';
        } else {
          morning = false;
          return 'Mañana';
        }
        case 'T': return 'Tarde';
        case 'N': return 'Noche';
        default: return '';
      }
    }

  }


  mostrar = () => {
    console.log('no');
  }

  onClick = (day, hour) => {
    try {
      this.props.onClickGraphic(this.props.name, { y: day, x: hour });
    } catch (e) { }
  }



  render() {
    return (
      <Grid item xs={12} >
        <div className={"ancho ancho-" + this.props.data.horas.length}>
          <Tooltip title={this.getTooltipTitle(this.props.data.dia)}>
            <div variant="outlined" className={"panel-square text-center"} style={{ width: '16px' }} key={this.props.data.dia}><p>{this.props.data.dia}</p></div>
          </Tooltip>


          {this.props.data.horas.map((val, i) =>
            <Tooltip title={this.getTooltipText(val)} key={'tooltip-dot-' + i}>
              <div
                variant="outlined"
                className={"panel-hover panel-square color-" + this.getColor(val) + " panel-square-" + this.props.data.horas.length}
                key={'matrix-line-tooltip-' + i}
                onClick={() => this.onClick(this.props.index, i)}
              >
              </div>
            </Tooltip>
          )}
        </div>
      </Grid>
    )
  }
}

export default MatrixLine;